import { EmailTemplateDto, EmailTemplateType, EmailTemplateViewModel } from '../models/email-template-dto';
import { client } from './client';

export async function getEmailTemplateByType(emailTemplateType: EmailTemplateType): Promise<EmailTemplateViewModel | null> {
  try {
    const response = await client.get<EmailTemplateViewModel>(`/EmailTemplates/type/${emailTemplateType}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching email template:', error);
    return null;
  }
}

export async function upsertEmailTemplate(emailTemplate: EmailTemplateDto): Promise<EmailTemplateViewModel> {
  const response = await client.post<EmailTemplateViewModel>('/EmailTemplates', emailTemplate);
  return response.data;
}

export async function deleteEmailTemplate(emailTemplateId: number): Promise<void> {
  await client.delete(`/EmailTemplates/${emailTemplateId}`);
}
